export const centsToDollars = (num: number) => {
  const dollars = num / 100
  return `$${dollars.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}
